import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../../services/axios';
import Swal from "sweetalert2";
import Table from '../../../components/common/table';
import TablePop from '../../../components/common/table-pop';
import config from '../../../config';
import { useJWTAuth } from '../../../services/JWTAuthProvider';
import { userRole } from '../../../constants/appConst';

export const TableUser = ({
    onSelectedRowsData,
    needRefresh,
    changeSelectedData,
    handleReSetPasswordClick
}) => {
    const [resetPopVisible] = useState(false);
    const [filteredData, setFilteredData] = React.useState([]);
    const [itemPerPage, setItemPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchText, setSearchText] = useState('');
    const [sortBy, setSortBy] = useState('');
    const [sortDirection, setSortDirection] = useState('');
    const [totalPages, setTotalPages] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [folderList, setFolderList] = React.useState([]);
    const [selectedFolder, setSelectedFolder] = React.useState("");
    const { user } = useJWTAuth();
    React.useEffect(() => {
        const getFolders = async () => {
            try {
                const { data } = await api.get("/Folders/getrootfolders?Id=" + user.id);
                if (data.statusCode === 200) {
                    const folders = data.result.folders;
                    setFolderList(folders);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        getFolders();
    }, []);

    const getData = async () => {
        try {
            setIsLoading(true);
            const params = new URLSearchParams();

            params.append("PageNumber", currentPage);
            params.append("PageSize", itemPerPage);

            if (searchText?.trim()) {
                params.append("SearchText", searchText.trim());
            }

            if (selectedFolder) {
                params.append("FolderIdentifier", selectedFolder);
            }

            if (sortBy) {
                params.append("SortBy", sortBy);
            }

            if (sortDirection) {
                params.append("SortingOrder", sortDirection);
            }

            const { data } = await api.get(
                `User/GetUserDetailsWithPagination?${params.toString()}`
            );
            // const { data } = await api.get("User/GetUserDetailsWithPagination?PageNumber=" + currentPage
            //     + "&PageSize=" + itemPerPage + "&SearchText=" + searchText + "&FolderIdentifier=" + selectedFolder
            //     + "&SortBy=" + sortBy + "&SortingOrder=" + sortDirection);
            setTotalPages(data.result.totalPages)
            setTotalCount(data.result.totalCount)
            setFilteredData(data.result.items);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        finally {
            setIsLoading(false);
        }
    }
    const onSorting = (sort, direction) => {
        setSortBy(sort)
        setSortDirection(direction)
    }
    React.useEffect(() => {
        getData();
    }, [itemPerPage, currentPage, searchText, selectedFolder, needRefresh, changeSelectedData, sortBy, sortDirection]);
    React.useEffect(() => {
        setCurrentPage(1);
    }, [selectedFolder, searchText]);

    const navigate = useNavigate();

    const handleEditClick = async (index) => {
        const selectedRow = filteredData[index];
        navigate('/EditUser', { state: { email: selectedRow.email, name: selectedRow.name, role: selectedRow.role, userIdentifier: selectedRow.uniqueIdentifier, ssoLogin: selectedRow.IsSSOLogin } });
    };

    const handleDeleteClick = (index) => {
        const selectedRow = filteredData[index];
        Swal.fire({
            html: 'Are you sure you want to delete this user <b>' + selectedRow.name + '</b>?',
            confirmButtonText: 'Delete',
            showDenyButton: true,
            denyButtonText: 'Cancel',
            icon: "warning",
            customClass: {
                actions: 'my-actions',
                cancelButton: 'order-2 right-gap',
                confirmButton: 'order-1',
                denyButton: 'order-3',
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {

                    const { data } = await api.delete("User/DeleteUser?UniqueIdentifier=" + selectedRow.uniqueIdentifier);
                    if (data.statusCode === 200) {
                        Swal.fire({
                            position: "center",
                            text: "User deleted successfully",
                            confirmButtonText: "Ok",
                            icon: "info",
                            timer: 3000,
                            timerProgressBar: true
                        }).then(() => {
                            // After successful deletion, update the currentPage state to 1
                            setCurrentPage(1); // Replace with your actual state updater function
                            getData();
                        });
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            }
        })
    };

    const handleActivateClick = async (index) => {
        const selectedRow = filteredData[index];
        Swal.fire({
            html: 'Are you sure you want to activate the user <b>' + selectedRow.name + '</b>?',
            confirmButtonText: 'Activate',
            showDenyButton: true,
            icon: "warning",
            denyButtonText: 'Cancel',
            customClass: {
                actions: 'my-actions',
                cancelButton: 'order-2 right-gap',
                confirmButton: 'order-1',
                denyButton: 'order-3',
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const { data } = await api.put("/user/ActivateDeActivateUser", {
                        uniqueIdentifier: selectedRow.uniqueIdentifier,
                    });
                    if (data.statusCode === 200) {
                        Swal.fire({
                            position: "center",
                            text: "User activated successfully",
                            confirmButtonText: "Ok",
                            icon: "info",
                            timer: 3000,
                            timerProgressBar: true
                        }).then(val => getData());;
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            }
        })
    };

    const handleDeactivateClick = async (index) => {
        const selectedRow = filteredData[index];
        Swal.fire({
            html: 'Are you sure you want to deactivate this user <b>' + selectedRow.name + '</b>?',
            confirmButtonText: 'Deactivate',
            showDenyButton: true,
            denyButtonText: 'Cancel',
            icon: "warning",
            customClass: {
                actions: 'my-actions',
                cancelButton: 'order-2 right-gap',
                confirmButton: 'order-1',
                denyButton: 'order-3',
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const { data } = await api.put("/user/ActivateDeActivateUser", {
                        uniqueIdentifier: selectedRow.uniqueIdentifier,
                    });
                    if (data.statusCode === 200) {
                        Swal.fire({
                            position: "center",
                            text: "User deactivated successfully",
                            confirmButtonText: "Ok",
                            timer: 3000,
                            icon: "info",
                            timerProgressBar: true
                        }).then(val => getData());
                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            }
        })
    };
    const filters = () => (
        <select
            className="form-select bu"
            value={selectedFolder}
            onChange={(e) => setSelectedFolder(e.target.value)}
        >
            <option value="">-- Select BU --</option>

            {folderList.map(folder => (
                <option
                    key={folder.folderIdentifier}
                    value={folder.folderIdentifier}
                >
                    {folder.name}
                </option>
            ))}
        </select>
    )
    const columns = [
        {
            key: 'name',
            title: 'User Name',
            sortEnabled: true
         },
        //{
        //     key: 'roleName',
        //     title: 'User Role',
        //     sortEnabled: true,
        //     sortName: 'role'
        // }, 
        {
            key: 'userId',
            title: 'User ID',
            sortEnabled: true
        },
        {
            key: 'folderName',
            title: 'Business Units',
            sortEnabled: true
        },
        {
            key: 'isActive',
            title: 'Status',
            sortEnabled: true,
            render: (item, index) => (
                <>
                    {
                        item.isActive == 1 ? <div>Active</div> : <div>Inactive</div>
                    }
                </>
            ),
        },
        {
            key: 'uniqueIdentifier',
            title: 'Action',
            width: '10%',
            render: (item, index) => (
                <>
                    {
                        <TablePop>
                            <div onClick={() => { handleEditClick(index) }} className='mb-2'><span className='pop-img'><img src='/Assets/edit.svg' alt='edit' /></span>Edit</div>
                            <div onClick={() => { handleDeleteClick(index) }} className='mb-2'><span className='pop-img'><img src='/Assets/delete-icon.svg' alt='delete' /></span>Delete</div>
                            {
                                config.SSODOMAIN.findIndex((val) => item.email.toLowerCase().includes(val)) >= 0 ? null :
                                    <div onClick={() => { handleReSetPasswordClick(item) }} className='mb-2'><span className='pop-img'><img src='/Assets/reset.svg' alt='reset' /></span>Reset Password</div>
                            }
                            {
                                item.isActive ?
                                    (<div onClick={() => { handleDeactivateClick(index) }} className='mb-2'><span className='pop-img'><img src='/Assets/deactivate.svg' alt='deactivate' /></span>Deactivate</div>) :
                                    (<div onClick={() => { handleActivateClick(index) }} className='mb-2'><span className='pop-img'><img src='/Assets/activate.svg' alt='activate' /></span>Activate</div>)
                            }
                        </TablePop>
                    }
                </>
            ),
        }
    ]
    return (
        <>
            <Table isLoading={isLoading} columns={columns} data={filteredData} handleItemsPerPageChange={(e) => setItemPerPage(e)} totalPages={totalPages}
                handleSearchChange={(e) => setSearchText(e)} bulkActionEnabled={true} currentPage={currentPage} itemsPerPage={itemPerPage}
                paginationEnabled={true} onRowselected={onSelectedRowsData} filters={filters}
                handleClickPageNumber={(e) => setCurrentPage(e)} totalItems={totalCount} onSorting={onSorting} />
            {resetPopVisible && (
                <div className="reset-pop">
                    <div>
                        <h5>Reseted password:</h5>
                        <p>Password</p>
                        <span className='close'>X</span>
                    </div>
                </div>
            )}
        </>
    )
}
